import React, { Component } from "react";
import { Modal } from "react-bootstrap";

export default class ElasticCartAd extends Component {
  render() {
    const {
      show = true,
      onHide = () => {},
      src = "/elasticcartad3.png",
      alt = "Advertisement",
      backdrop = false,
    } = this.props;

    return (
      <>
        <style>{`
          .ecad-borderless .modal-content {
            border: none !important;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          }

          .ecad-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh; /* take full viewport height */
            padding: 16px;
          }

          @media (max-width: 576px) {
            .ecad-borderless .modal-content {
              border-radius: 0;
              height: 100vh; /* take full height on mobile */
            }
            .ecad-body {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%; /* center content vertically */
              padding: 16px;
            }
          }

          .ecad-img {
            display: block;
            max-width: 100%;
            height: auto;
            max-height: 80vh; /* never overflow screen */
            object-fit: contain;
            margin: 0 auto;
          }

          @keyframes ecad-bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-6px); }
          }
          .ad-bounce {
            animation: ecad-bounce 1.6s ease-in-out infinite;
          }

          @media (prefers-reduced-motion: reduce) {
            .ad-bounce { animation: none !important; }
          }

          .ecad-close {
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 2;
            border: 0;
            background: rgba(255,255,255,0.9);
            width: 36px;
            height: 36px;
            border-radius: 9999px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
 
        `}</style>

        {/* <Modal
          show={show}
          onHide={onHide}
          centered
          size="lg"
          backdrop={backdrop}
          keyboard
          className="ecad-borderless"
          fullscreen="sm-down"
        >
          <Modal.Body className="ecad-body text-center p-0 bg-white position-relative">
            <button
              type="button"
              className="ecad-close"
              aria-label="Close advertisement"
              onClick={onHide}
            >
              ×
            </button>

            <img
              src={src}
              alt={alt}
              className="ecad-img ad-bounce"
              loading="lazy"
            />
          </Modal.Body>
        </Modal> */}
        <div className="ecad-wrapper">
          <img
            src={src}
            alt={alt}
            className="ecad-img ad-bounce"
            loading="lazy"
          />
        </div>
      </>
    );
  }
}
